import React, { useContext, useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { LoginFormContext } from "context/LoginFormContext";
import { MODULES } from "helpers/constant";
import DefaultCell from "examples/Tables/DataTable/components/DefaultCell";
import { SEARCH_INPUT_TYPES } from "helpers/constant";
import moment from "moment";
import { eventBookingList } from "Apis/eventBooking";
import jsPDF from "jspdf";
import QRCode from "qrcode";
import day1 from "assets/images/AGRT 1st day.png";
import day2 from "assets/images/AGRT 2nd.png";
import logo from "assets/images/agrt-icon.png";
import EventBookingForm from "./Form";
import MDModal from "components/MDModal";
import { ModalContext } from "context/ModalContext";
import {
  Avatar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import ExtraCollapse from "examples/Tables/ExtraCollapse";
import dayjs from "dayjs";
import MDTypography from "components/MDTypography";
import colors from "assets/theme/base/colors";
import { Cancel, CheckCircle, ContentCopy, MoreVert } from "@mui/icons-material";
import { updateBookingStatus } from "Apis/eventBooking";
import DownloadIcon from "@mui/icons-material/Download";
import Imagepreview from "components/MDImagePreview";

const EventBooking = () => {
  const { showMessageNotification, setOpen, formIsEdit, setFormIsEdit } = useContext(ModalContext);
  const [copiedStates, setCopiedStates] = useState({});
  const { setNotification } = useContext(LoginFormContext);
  const { imageBorder } = colors;
  const {
    modules,
    getModuleAccess,
    isLoading,
    setIsLoading,
    filterLoader,
    setFilterLoader,
    access,
  } = useContext(LoginFormContext);

  const [eventBookings, setEventBookings] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [defaultFilter, setDefaultFilter] = useState({
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: [{ id: "id", value: "desc" }],
  });

  const [filterVal, setFilterVal] = useState({
    id: "",
    title: "",
    name: "",
    start_date: "",
    no_of_bookings: "",
    total_pass: "",
    total_amount: "",
    status: "",
    transaction_status: "",
  });

  const handleFilter = (accessor, value) => {
    setFilterLoader(true);
    setFilterVal({ ...filterVal, [accessor]: value });
    setDefaultFilter((prev) => ({ ...prev, currentPage: 1 }));
  };
  const getQrCodeUrl = (data, size = 200) => {
    if (!data) return null;

    const encodedData = encodeURIComponent(data);
    return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodedData}`;
  };

  const generateAndDownloadQR = async (
    templateImage,
    ticketData,
    fileName = "qr-template",
    qrSize,
    left,
    top
  ) => {
    try {
      // Extract ticket_id from the ticket object
      const dataString = JSON.stringify(ticketData);

      // Generate QR code using Google Charts API
      const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(dataString)}`;

      // Create canvas
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // Load template image
      const templateImg = new Image();
      templateImg.crossOrigin = "anonymous";

      await new Promise((resolve, reject) => {
        templateImg.onload = resolve;
        templateImg.onerror = reject;
        templateImg.src = templateImage;
      });

      // Set canvas size to template size
      canvas.width = templateImg.width;
      canvas.height = templateImg.height;

      // Draw template image
      ctx.drawImage(templateImg, 0, 0);

      // Load QR code image
      const qrImg = new Image();
      qrImg.crossOrigin = "anonymous";

      await new Promise((resolve, reject) => {
        qrImg.onload = resolve;
        qrImg.onerror = reject;
        qrImg.src = qrCodeUrl;
      });

      // Draw QR code at position
      ctx.drawImage(qrImg, left, top, qrSize, qrSize);

      // Convert canvas to blob and download
      canvas.toBlob((blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${fileName}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, "image/png");

      return { success: true, message: "QR code downloaded successfully" };
    } catch (error) {
      console.error("Error generating QR code:", error);
      return { success: false, message: error.message };
    }
  };

  // Example Component Usage
  const QRDownloadButton = ({ templateImage, ticketData, qrSize, left, top }) => {
    const handleDownload = async () => {
      const result = await generateAndDownloadQR(
        templateImage,
        ticketData,
        "event-qr-template",
        qrSize,
        left,
        top
      );
      if (result.success) {
      } else {
        alert("Failed to download QR code: " + result.message);
      }
    };

    return (
      <Button
        variant="outlined"
        color="primary"
        onClick={handleDownload}
        sx={{
          minWidth: 40,
          padding: 1,
          borderRadius: 2,
        }}
      >
        <DownloadIcon color="primary" />
      </Button>
    );
  };

  let Obj = {
    ...defaultFilter,
    filters: {
      id: filterVal?.id,
      title: filterVal?.title,
      name: filterVal?.name,
      start_date: filterVal?.start_date,
      no_of_bookings: filterVal?.no_of_bookings,
      total_pass: filterVal?.total_pass,
      total_amount: filterVal?.total_amount,
      status: filterVal?.status?.value,
      transaction_status: filterVal?.transaction_status?.value,
    },
  };

  const eventBookingData = async () => {
    let response = await eventBookingList(Obj);
    filterLoader ? setIsLoading(false) : setIsLoading(true);
    if (response?.status === 200) {
      setEventBookings(response?.data?.data?.rows);
      setRowCount(response?.data?.data?.count);
      setIsLoading(false);
    }
  };

  // Helper function to get ticket image path based on event date
  const getTicketImagePath = (eventDate) => {
    if (!eventDate) return day1;
    const date = new Date(eventDate);
    const day = date.getDate();
    return day === 22 ? day1 : day2;
  };

  // Helper function to load image as base64
  const loadImageAsBase64 = (imagePath) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;

        ctx.drawImage(img, 0, 0);
        const base64 = canvas.toDataURL("image/png");
        resolve(base64);
      };

      img.onerror = () => reject(new Error(`Failed to load image: ${imagePath}`));
      img.src = imagePath;
    });
  };

  useEffect(() => {
    getModuleAccess(MODULES.EVENT_BOOKING);
  }, [modules]);

  useEffect(() => {
    eventBookingData();
  }, [filterVal, defaultFilter]);

  const handleEditDelete = async (rowData, action) => {
    const statusType = {
      status: action,
      transaction_status: action === 1 ? 1 : 4,
      id: rowData?.id,
    };
    const response = await updateBookingStatus(statusType);
    eventBookingData();
    if (response?.status === 200) {
      setNotification({
        color: "success",
        icon: "check",
        title: "Success",
        content: response.data.message,
        open: true,
      });
    }
  };

  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsImageModalOpen(true);
  };

  const renderSubRow = ({ row }) => {
    const bookings = row.original.event_booked_by_members;
    if (!bookings || bookings.length === 0) {
      return (
        <MDBox p={3} sx={{ backgroundColor: "#fafafa", textAlign: "center" }}>
          <MDTypography variant="body2" color="textSecondary">
            No booking details available for this booking.
          </MDTypography>
        </MDBox>
      );
    }

    return (
      <MDBox sx={{ width: "100%", backgroundColor: "#fafafa" }}>
        {bookings.map((booking, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              p: row?.original?.status != 1 ? 2.5 : 1,
              px: 5,
              borderBottom: "1px solid",
              borderColor: "divider",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {booking?.member?.member_images[0]?.image && booking?.is_member_guest !== 1 ? (
                <img
                  src={booking?.member?.member_images[0]?.image}
                  onClick={() => handleImageClick(booking?.member?.member_images[0]?.image)}
                  alt="image"
                  style={{
                    height: "50px",
                    width: "50px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: `1px solid ${imageBorder.borderColor}`,
                    cursor: "pointer",
                  }}
                />
              ) : (
                <Avatar
                  style={{
                    height: "50px",
                    width: "50px",
                    borderRadius: "100%",
                    objectFit: "fill",
                  }}
                />
              )}

              <Box sx={{ minWidth: "300px", maxWidth: "300px" }}>
                <Typography variant="body2" fontWeight="medium">
                  {booking?.member_only === true && booking?.is_member_guest !== 1
                    ? `${booking?.member?.first_name?.trim() || ""} ${booking?.member?.middle_name?.trim() || ""} ${booking?.member?.surname?.trim() || ""}`.trim()
                    : `#${booking?.ticket_id} ${booking?.is_member_guest === 1 ? `( Guest )` : ""}`}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {booking?.member_only === true &&
                  booking?.member?.email &&
                  booking?.is_member_guest !== 1
                    ? booking?.member?.email
                    : booking?.member?.mobile_number != 0 &&
                        booking?.member_only === true &&
                        booking?.is_member_guest !== 1 &&
                        booking?.member?.mobile_number
                      ? booking?.member?.mobile_number
                      : null}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {row.original?.status === 1 &&
                (() => {
                  const ticketId = booking?.ticket_id;
                  const qrCodeUrl = getQrCodeUrl(ticketId);

                  return (
                    <>
                      <Box
                        component="img"
                        src={qrCodeUrl}
                        alt={`QR code for ticket ${ticketId}`}
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: 1,
                          // border: "1px solid #ddd",
                          p: 0.5,
                          // backgroundColor: "#fff",
                        }}
                      />
                      <QRDownloadButton
                        templateImage={booking?.qr_template?.temp_image}
                        ticketData={{ ticket_id: booking?.ticket_id }}
                        qrSize={booking?.qr_template?.desk_qr_size}
                        left={booking?.qr_template?.desk_qr_x}
                        top={booking?.qr_template?.desk_qr_y}
                      />
                    </>
                  );
                })()}
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box sx={{ minWidth: "300px", maxWidth: "300px" }}>
                <Typography variant="body2" fontWeight="medium">
                  Member Booking Id
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  #{booking?.id}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{ display: "flex", alignItems: "center", padding: "10px", marginRight: "40px" }}
            >
              <Typography variant="body2">
                {booking?.createdAt ? dayjs(booking.createdAt).format("DD MMM YYYY hh:mm A") : "-"}
              </Typography>
            </Box>
          </Box>
        ))}
      </MDBox>
    );
  };

  let data = {
    isFilter: true,
    columns: [
      {
        Header: "Event Booking Id",
        accessor: "id",
        minWidth: "120px",
        sort: true,
        filterLabel: "Event Booking Id",
        filterAccessor: "id",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value ? `#${value}` : "-"} />,
      },
      {
        Header: "Event Name",
        accessor: "event.title",
        minWidth: "120px",
        filterLabel: "Event Name",
        filterAccessor: "title",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value, row }) => {
          const event = row?.original?.event;
          if (!event) return <DefaultCell value={"-"} />;

          const startDate = event?.start_date
            ? moment(event.start_date).format("YYYY-MM-DD")
            : null;
          const endDate = event?.end_date ? moment(event.end_date).format("YYYY-MM-DD") : null;
          let dateLine = startDate || "-";
          if (startDate && endDate && startDate !== endDate) {
            dateLine = `${startDate} to ${endDate}`;
          }

          return (
            <DefaultCell
              value={
                <div style={{ display: "flex", flexDirection: "column", minWidth: 120, gap: 5 }}>
                  <span>{value}</span>
                  <span style={{ fontWeight: 500 }}>{`(${dateLine})`}</span>
                </div>
              }
            />
          );
        },
      },
      {
        Header: "Head Member",
        accessor: "member.first_name",
        minWidth: "180px",
        filterLabel: "Customer Name",
        filterAccessor: "name",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ row }) => {
          const member = row?.original?.member;
          const fullName = member
            ? `${member.first_name || ""} ${member.middle_name || ""} ${member.surname || ""}`.trim()
            : "-";

          const imageUrl = row?.original?.member?.member_images[0]?.member_image;
          const [imgError, setImgError] = React.useState(false);
          return (
            <DefaultCell
              value={
                member ? (
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    {imageUrl && !imgError ? (
                      <img
                        src={imageUrl}
                        alt="image"
                        onError={() => setImgError(true)}
                        style={{
                          height: "50px",
                          width: "50px",
                          borderRadius: "100%",
                          objectFit: "cover",
                          border: `1px solid ${imageBorder.borderColor}`,
                        }}
                      />
                    ) : (
                      <Avatar
                        style={{
                          height: "50px",
                          width: "50px",
                          borderRadius: "100%",
                          objectFit: "fill",
                        }}
                      />
                    )}

                    <span>{fullName || "-"}</span>
                  </div>
                ) : (
                  "-"
                )
              }
            />
          );
        },
      },
      {
        Header: "No Of Booking",
        accessor: "no_of_bookings",
        minWidth: "120px",
        sort: true,
        filterLabel: "No of Booking",
        filterAccessor: "no_of_bookings",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
      },
      {
        Header: "Total Amount",
        accessor: "total_amount",
        minWidth: "120px",
        sort: true,
        filterLabel: "Total Amount",
        filterAccessor: "total_amount",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
      },
      {
        Header: "Payment Link",
        accessor: "payment_link",
        minWidth: "150px",
        Cell: ({ value, row }) => {
          const paymentLink = row?.original?.order_transactions?.[0]?.payment_link;

          const rowId = row?.original?.id;
          const isCopied = copiedStates[rowId] || false;

          const handleCopy = async () => {
            if (paymentLink) {
              try {
                await navigator.clipboard.writeText(paymentLink);
                setCopiedStates((prev) => ({ ...prev, [rowId]: true }));
                setTimeout(() => {
                  setCopiedStates((prev) => ({ ...prev, [rowId]: false }));
                }, 1500);
              } catch (error) {
                console.error("Failed to copy:", error);
              }
            }
          };

          return (
            <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
              <Box
                sx={{
                  maxWidth: 150,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "flex",
                  justifyContent: paymentLink ? "flex-start" : "center",
                  width: "100%",
                }}
              >
                {paymentLink ?? "-"}
              </Box>
              {paymentLink && (
                <Tooltip title={isCopied ? "Copied!" : "Copy"}>
                  <IconButton size="small" onClick={handleCopy}>
                    <ContentCopy fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          );
        },
      },
      {
        Header: "Booking Date & Time",
        accessor: "createdAt",
        minWidth: "120px",
        filterLabel: "",
        filterAccessor: "",
        filterInputType: "",
        filterHandleChange: handleFilter,
        Cell: ({ value, row }) => {
          const bookingDate = value ? moment(value).format("DD MMM YYYY hh:mm A") : null;
          return <DefaultCell value={bookingDate ? bookingDate : "-"} />;
        },
      },
      {
        Header: "Transaction Date & Time",
        accessor: "order_transactions[0].updatedAt",
        minWidth: "120px",
        filterLabel: "",
        filterAccessor: "",
        filterInputType: "",
        filterHandleChange: handleFilter,
        Cell: ({ value }) => {
          const updatedDate = value ? moment(value).format("DD MMM YYYY hh:mm A") : null;
          return <DefaultCell value={updatedDate ? updatedDate : "-"} />;
        },
      },
      {
        Header: "Booking Status",
        accessor: "status",
        minWidth: "100px",
        sort: true,
        filterLabel: "Booking Status",
        filterAccessor: "status",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Confirmed", value: "1" },
          { label: "Pending", value: "0" },
          { label: "Cancelled", value: "2" },
        ],
        Cell: ({ value }) => {
          const getStatusLabel = (statusValue) => {
            switch (statusValue) {
              case 1:
              case "1":
                return "Confirmed";
              case 0:
              case "0":
                return "Pending";
              case 2:
              case "2":
                return "Cancelled";
              default:
                return "-";
            }
          };

          return (
            <MDBox
              sx={{
                display: "inline-block",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "12px",
                fontWeight: "bold",
                textTransform: "capitalize",
                backgroundColor:
                  value === 1 || value === "1"
                    ? "#e8f5e8"
                    : value === 0 || value === "0"
                      ? "#fff3cd"
                      : value === 2 || value === "2"
                        ? "#f8d7da"
                        : "#f8f9fa",
                color:
                  value === 1 || value === "1"
                    ? "#155724"
                    : value === 0 || value === "0"
                      ? "#856404"
                      : value === 2 || value === "2"
                        ? "#721c24"
                        : "#495057",
              }}
            >
              {getStatusLabel(value)}
            </MDBox>
          );
        },
      },
      {
        Header: "Transaction Status",
        accessor: "order_transactions[0].transaction_status",
        minWidth: "100px",
        filterLabel: "",
        filterAccessor: "",
        filterInputType: "",
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Success", value: "1" },
          { label: "Pending", value: "0" },
          { label: "Failed", value: "2" },
          { label: "Success", value: "3" },
          { label: "Cancelled", value: "4" },
        ],
        Cell: ({ value }) => {
          const getStatusLabel = (statusValue) => {
            switch (statusValue) {
              case 1:
              case "1":
                return "Success";
              case 0:
              case "0":
                return "Pending";
              case 2:
              case "2":
                return "Failed";
              case 3:
              case "3":
                return "Success";
              case 4:
              case "4":
                return "Cancelled";
              default:
                return "-";
            }
          };

          return (
            <MDBox
              sx={{
                display: "inline-block",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "12px",
                fontWeight: "bold",
                textTransform: "capitalize",
                backgroundColor:
                  value === 1 || value === "1"
                    ? "#e8f5e8"
                    : value === 0 || value === "0"
                      ? "#fff3cd"
                      : value === 2 || value === "2"
                        ? "#e8d1b6ff"
                        : value === 3 || value === "3"
                          ? "#d4d5c0ff"
                          : value === 4 || value === "4"
                            ? "#f8d7da"
                            : "#f8f9fa",
                color:
                  value === 1 || value === "1"
                    ? "#155724"
                    : value === 0 || value === "0"
                      ? "#856404"
                      : value === 2 || value === "2"
                        ? "#721c24"
                        : value === 3 || value === "3"
                          ? "#2b4431ff"
                          : value === 4 || value === "4"
                            ? "#721c24"
                            : "#495057",
              }}
            >
              {getStatusLabel(value)}
            </MDBox>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "actions",
        minWidth: "120px",
        Cell: ({ row }) => {
          const [localAnchorEl, setLocalAnchorEl] = React.useState(null);

          const handleClick = (event) => {
            event.stopPropagation();
            setLocalAnchorEl(event.currentTarget);
          };

          const handleClose = () => {
            setLocalAnchorEl(null);
          };

          return (
            row.original.status == 0 &&
            row.original.status == "0" && (
              <Box display="flex" gap={0.5} position="relative">
                {access?.write_access && (
                  <>
                    <IconButton
                      size="small"
                      onClick={handleClick}
                      sx={{
                        borderRadius: 1,
                        padding: "2px",
                      }}
                    >
                      <MoreVert fontSize="small" />
                    </IconButton>

                    <Menu
                      anchorEl={localAnchorEl}
                      open={Boolean(localAnchorEl)}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      slotProps={{
                        paper: {
                          sx: {
                            m: 0.5,
                            p: 0.5,
                            minWidth: 120,
                          },
                        },
                      }}
                    >
                      {row.original.status !== 1 && row.original.status !== "1" && (
                        <MenuItem
                          onClick={() => {
                            handleEditDelete(row?.original, 1);
                            handleClose();
                          }}
                          sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                        >
                          <CheckCircle fontSize="small" color="success" />
                          Confirm
                        </MenuItem>
                      )}
                      <MenuItem
                        onClick={() => {
                          handleEditDelete(row?.original, 2);
                          handleClose();
                        }}
                        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                      >
                        <Cancel fontSize="small" color="error" />
                        Cancel
                      </MenuItem>
                    </Menu>
                  </>
                )}
              </Box>
            )
          );
        },
      },
    ],
    rows: eventBookings,
  };

  return (
    !isLoading && (
      <>
        <DashboardLayout>
          <DashboardNavbar />
          <MDModal
            hasButton={access?.write_access ?? false}
            btnText="add event booking"
            modalHead={`${formIsEdit ? "Edit" : "Add"} Event Booking`}
          >
            <EventBookingForm eventBookingData={eventBookingData} />
          </MDModal>
          <ExtraCollapse
            table={data}
            isSorted={false}
            entriesPerPage={true}
            showTotalEntries={true}
            noEndBorder
            canFilter
            getDataList={eventBookingData}
            rowCount={rowCount}
            tableTitle="Event Booking List"
            defaultFilter={defaultFilter}
            setDefaultFilter={setDefaultFilter}
            renderSubRow={renderSubRow}
          />
          {selectedImage && (
            <Imagepreview
              open={isImageModalOpen}
              onClose={() => setIsImageModalOpen(false)}
              imageUrl={selectedImage}
            />
          )}
        </DashboardLayout>
      </>
    )
  );
};

EventBooking.propTypes = {
  value: PropTypes.string,
  row: PropTypes.string,
};

export default EventBooking;
